import { Alert, AlertDescription, AlertTitle, Button, cn } from '@kalos/ui';

type LoadErrorStateProps = {
  /** What failed, for example "Couldn't load documents". */
  title: string;
  description?: string;
  /** Names the action and the object, for example "Retry loading documents". */
  retryLabel: string;
  onRetry: () => void;
  isRetrying: boolean;
  className?: string;
};

/**
 * Shown in place of content when a load fails. Uses the danger tint so it can't be
 * mistaken for `EmptyState`, and always offers a retry.
 */
export const LoadErrorState = ({
  title,
  description = 'Check your connection, then try again.',
  retryLabel,
  onRetry,
  isRetrying,
  className,
}: LoadErrorStateProps) => (
  <Alert className={cn('bg-danger text-danger-foreground border-danger-foreground/30', className)}>
    <AlertTitle>{title}</AlertTitle>
    <AlertDescription className="flex flex-wrap items-center justify-between gap-2">
      <p>{description}</p>
      <Button variant="outline" disabled={isRetrying} onClick={onRetry}>
        {isRetrying ? 'Retrying…' : retryLabel}
      </Button>
    </AlertDescription>
  </Alert>
);
